import React from "react";
import "./ScrollArea.css";

type ScrollAreaProps = {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

const ScrollArea = React.forwardRef<HTMLDivElement, ScrollAreaProps>(
  ({ children, className, style, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={`scroll-area ${className || ""}`}
        style={style}
        {...props}
      >
        <div className="scroll-viewport">{children}</div>
        <ScrollBar orientation="vertical" />
        <ScrollBar orientation="horizontal" />
      </div>
    );
  }
);

type ScrollBarProps = {
  orientation?: "vertical" | "horizontal";
  className?: string;
};

const ScrollBar = React.forwardRef<HTMLDivElement, ScrollBarProps>(
  ({ orientation = "vertical", className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={`scrollbar ${orientation} ${className || ""}`}
        {...props}
      >
        <div className="scroll-thumb" />
      </div>
    );
  }
);

export { ScrollArea, ScrollBar };
